import React, { useEffect, useState } from "react";
import styles from "./learningToolButtons.module.css";
import { IoAddCircleOutline } from "react-icons/io5";
import { FaXmark } from "react-icons/fa6";
import { ImStarFull } from "react-icons/im";

const LearningToolButtons = ({
  onDeleteTool,
  handleAddNewUnit,
  unitsNum,
  maxUnitsPerTool,
}) => {
  /* Display the two learning tool buttons: add unit, and delete tool. */

  const [isAddingUnitAllowed, setIsAddingUnitAllowed] = useState(true);

  /* Check if adding a new unit is allowed based on the number of units in the learning tool and the maximum allowed units per tool. */
  useEffect(() => {
    setIsAddingUnitAllowed(unitsNum < maxUnitsPerTool);
  }, [unitsNum, maxUnitsPerTool]);

  /**
   * Delete the tool (the passed onDeleteTool function will run, and the confirmation modal will be shown)
   */
  const handleDeleteToolBtnClick = () => {
    onDeleteTool();
  };

  return (
    <div className={styles.learningToolBtns}>
      {isAddingUnitAllowed ? (
        <button className={styles.addUnitIcon} onClick={handleAddNewUnit}>
          <IoAddCircleOutline />
        </button>
      ) : (
        <div className={`${styles.tooltip} ${styles.starIcon}`}>
          <ImStarFull />
          <span className={styles.tooltiptext}>
            Maximum units reached, can't add more
          </span>
        </div>
      )}

      <button
        className={styles.deleteToolIcon}
        onClick={handleDeleteToolBtnClick}
      >
        <FaXmark />
      </button>
    </div>
  );
};

export default LearningToolButtons;
